import ApiService from "@/core/services/api.service";

// action types
export const FETCH_USER_TOKENS = "fetchUserTokens";
export const DESTROY_USER_TOKEN = "destroyUserToken";

export const FETCH_API_TOKENS = "fetchApiTokens";
export const STORE_API_TOKEN = "storeApiToken";
export const DESTROY_API_TOKEN = "destroyApiToken";

// mutation types
export const SET_USER_TOKENS = "setUserTokens";
export const SET_API_TOKENS = "setApiTokens";

const state = {
  userTokens: {},
  apiTokens: {}
};

const getters = {
  userTokens(state) {
    return state.userTokens;
  },
  apiTokens(state) {
    return state.apiTokens;
  }
};

const actions = {
  [FETCH_USER_TOKENS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("user-tokens")
        .then(({ data }) => {
          context.commit(SET_USER_TOKENS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_USER_TOKEN](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`user-tokens/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  },

  [FETCH_API_TOKENS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("api-tokens")
        .then(({ data }) => {
          context.commit(SET_API_TOKENS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_API_TOKEN](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("api-tokens", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_API_TOKEN](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`api-tokens/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_USER_TOKENS](state, data) {
    state.userTokens = data;
  },
  [SET_API_TOKENS](state, data) {
    state.apiTokens = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
